import React from 'react';
import useThemeCanvas, { pulseRgb } from '../useThemeCanvas';

const FONT_SIZE = 18;
const CHARS = 'アイウエオカキクケコサシスセソタチツテトナニヌネノハヒフヘホマミムメモヤユヨラリルレロワヲン0123456789'.split('');

export default function MatrixTheme({ palette, colorMode, dark }) {
  const canvasRef = useThemeCanvas({
    init: (ctx, w, h, state) => {
      const cols = Math.ceil(w / FONT_SIZE);
      // Per-column speed/brightness give the rain depth; a glyph buffer keeps a
      // short trail so heads aren't redrawn as random noise each frame.
      state.cols = Array.from({ length: cols }, () => ({
        y: Math.random() * (h / FONT_SIZE),
        speed: 0.45 + Math.random() * 0.75,
        glyph: CHARS[Math.floor(Math.random() * CHARS.length)],
        tick: 0,
      }));
    },
    draw: (ctx, w, h, state, t) => {
      // Translucent clear leaves a soft fading trail behind each head.
      ctx.fillStyle = dark ? 'rgba(3,7,18,0.10)' : 'rgba(249,250,251,0.12)';
      ctx.fillRect(0, 0, w, h);

      const rgb = pulseRgb(palette, t, colorMode === 'cycling' ? 0.3 : 0.04);
      ctx.font = `${FONT_SIZE}px monospace`;
      ctx.textBaseline = 'top';

      const cols = state.cols || [];
      for (let i = 0; i < cols.length; i++) {
        const col = cols[i];
        const x = i * FONT_SIZE;
        const y = Math.floor(col.y) * FONT_SIZE;
        const depth = (col.speed - 0.45) / 0.75; // 0 far .. 1 near

        // Occasionally mutate the glyph so the head shimmers instead of flickering.
        if ((col.tick = (col.tick + 1) % 6) === 0) {
          col.glyph = CHARS[Math.floor(Math.random() * CHARS.length)];
        }

        // Two short trailing glyphs (the fade fill extends the tail further).
        ctx.shadowBlur = 0;
        for (let k = 1; k <= 2; k++) {
          ctx.fillStyle = `rgba(${rgb.r},${rgb.g},${rgb.b},${(0.3 + 0.25 * depth) / k})`;
          ctx.fillText(CHARS[(i + k) % CHARS.length], x, y - k * FONT_SIZE);
        }

        // Glowing head
        ctx.shadowBlur = 10 + 8 * depth;
        ctx.shadowColor = `rgba(${rgb.r},${rgb.g},${rgb.b},0.9)`;
        ctx.fillStyle = dark
          ? `rgba(${200 + Math.round(55 * depth)},255,${220},${0.85 + 0.15 * depth})`
          : `rgba(${rgb.r},${rgb.g},${rgb.b},${0.85 + 0.15 * depth})`;
        ctx.fillText(col.glyph, x, y);
        ctx.shadowBlur = 0;

        if (y > h && Math.random() > 0.975) {
          col.y = 0;
          col.speed = 0.45 + Math.random() * 0.75;
        }
        col.y += col.speed;
      }
    },
  });
  return <canvas ref={canvasRef} className="absolute inset-0" />;
}
